import clsx from "clsx";

type HeadingProps = {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
} & React.ComponentPropsWithoutRef<"h1" | "h2" | "h3" | "h4" | "h5" | "h6">;

export function Heading({ className, level = 1, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "text-2xl font-semibold text-zinc-950 sm:text-3xl dark:text-white"
      )}
    />
  );
}

export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "text-base font-semibold text-zinc-950 sm:text-lg/6 dark:text-white"
      )}
    />
  );
}

export function Sectionheading({
  className,
  level = 3,
  ...props
}: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "text-lg font-medium text-[var(--color-accent)] dark:text-[var(--color-accent-light)]"
      )}
    />
  );
}

export function Subsectionheading({
  className,
  level = 4,
  ...props
}: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "text-sm font-medium text-zinc-700 sm:text-base dark:text-zinc-300"
      )}
    />
  );
}

export function Title({ className, level = 5, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "text-base font-medium text-zinc-800 dark:text-zinc-300"
      )}
    />
  );
}

export function SubTitle({ className, level = 5, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "text-sm font-medium text-zinc-800 dark:text-zinc-300"
      )}
    />
  );
}
